import React, { useState, useEffect } from "react";
import styles from "./HeaderBanner.module.css";

import imagebanner1 from "../../../assets/images/Header/emam-port-1.png";
import imagebanner2 from "../../../assets/images/Header/emam-port.png";
import imagebanner3 from "../../../assets/images/Header/gps wallpaper 1.jpg";
import imagebanner4 from "../../../assets/images/Header/gps wallpaper 2.png";
import imagebanner5 from "../../../assets/images/Header/gps wallpaper 3.jpg";
import imagebanner6 from "../../../assets/images/Header/h-2.jpg";
import imagebanner7 from "../../../assets/images/Header/illustrative person car at night.png";
import imagebanner8 from "../../../assets/images/Header/banner1.png";

function HeaderBanner() {
  const bannerImages = [
    {
      id: 0,
      name: "emam-port-1",
      src: imagebanner1,
      figCap: "Caption",
    },
    {
      id: 1,
      name: "emam-port",
      src: imagebanner2,
      figCap: "Caption",
    },
    {
      id: 2,
      name: "gps wallpaper 1",
      src: imagebanner3,
      figCap: "Caption",
    },
    {
      id: 3,
      name: "gps wallpaper 2",
      src: imagebanner4,
      figCap: "Caption",
    },
    {
      id: 4,
      name: "gps wallpaper 3",
      src: imagebanner5,
      figCap: "Caption",
    },
    {
      id: 5,
      name: "h-2.jpg",
      src: imagebanner6,
      figCap: "Caption",
    },
    {
      id: 6,
      name: "illustrative person car at night",
      src: imagebanner7,
      figCap: "Caption",
    },
    {
      id: 7,
      name: "illustrative person car at night",
      src: imagebanner8,
      figCap: "Caption",
    },
  ];
  // const [currentBanner, setCurrentBanner] = useState(0);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrentBanner((prevBanner) => (prevBanner + 1) % bannerImages.length);
  //     console.log("banner changed");
  //   }, 3000);

  //   return () => clearInterval(interval); // Cleanup on unmount
  // }, [bannerImages.length]);

  return (
    <>
      <div
        className={`Header-banner__container ${styles.HeaderBannerContainer}`}>
        <div className={`Header-banner ${styles.HeaderBanner} `}>
          <figure className="banner">
            <img
              className={`${styles.bannerImage} banner__image`}
              src={bannerImages[bannerImages.length - 1].src}
              alt={bannerImages[bannerImages.length - 1].name}
            />
          </figure>
        </div>
      </div>
    </>
  );
}

export default HeaderBanner;
